import React, { useState, useContext, useEffect } from "react";
// react-bootstrap components
import { Container, Row, Col } from "react-bootstrap";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import StoreContext from "contexts/StoreContext";
import IntegrationProductsTable from "components/Tables/IntegrationProductsTable";
import StoreProductsTable from "components/Tables/StoreProductsTable";

import { useTranslation } from "react-i18next";

function ProductsIntegrationPage() {
  const {
    t,
  } = useTranslation();

  const { storeId, setStoreId } = useContext(StoreContext);
  const [alert, setAlert] = useState(null);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [storeProductId, setStoreProductId] = useState(null);
  const [matchedIntegrationIds, setMatchedIntegrationIds] = useState([]);

  const [refresh, setRefresh] = useState(false);

  const handleMatchedIntegrationIds = (ids) => {
    setMatchedIntegrationIds(ids.flatMap((str) => str.split(";")));
  };

  const handleRowSelect = (id) => {
    setStoreProductId((prevId) => (prevId === id ? null : id));
  };

  const handleCheckboxToggle = (id) => {
    const stringId = String(id);
    setMatchedIntegrationIds((prevIds) => {
      const normalizedPrevIds = prevIds.map(String);
      return normalizedPrevIds.includes(stringId) ? normalizedPrevIds.filter((prevId) => prevId !== stringId) : [...normalizedPrevIds, stringId];
    });
  };

  const patchProducts = () => {
    const integrator = getIntegratorById(selectedIntegration);
    apiService
      .patch(`api/v1/products/${storeProductId}/${integrator}/`, matchedIntegrationIds)
      .then((resp) => {
        notificationService.notifySuccess(t("messages.productsMatchedSuccessfully"));
        setRefresh((prev) => !prev);
        setAlert(null);
        setStoreProductId(null);
        setMatchedIntegrationIds([]);
      })
      .catch((error) => {
        console.error(error);
        notificationService.notifyError(t("messages.unableToMatchProducts"));
        setAlert(null);
      });
  };

  const getIntegratorById = (integratorId) => {
    if (integratorId == 1) return "efood";
    if (integratorId == 2) return "wolt";
    if (integratorId == 3) return "box";
    if (integratorId == 5) return "gonnaorder";
    if (integratorId == 6) return "deliverymanager";
    if (integratorId == 7) return "fluter";
    if (integratorId == 11) return "culizen";
    if (integratorId == 14) return "orderoo";
    console.error("Unknown integrator with id ", integratorId);
  };

  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col md="6">
            <StoreProductsTable
              storeId={storeId}
              onRowSelect={(id) => handleRowSelect(id)}
              selectedIntegration={selectedIntegration}
              refresh={refresh}
              sendMatchedIntegrationIds={handleMatchedIntegrationIds}
              selectedRowId={storeProductId}
            />
          </Col>
          <Col md="6">
            <IntegrationProductsTable
              storeId={storeId}
              onCheckboxToggle={(id) => handleCheckboxToggle(id)}
              selectedIntegration={selectedIntegration}
              onSelectIntegration={setSelectedIntegration}
              selectedStoreProductId={storeProductId}
              matchedIds={matchedIntegrationIds}
              onSubmit={patchProducts}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ProductsIntegrationPage;
